import { BroadcastService } from './../../services/broadcast.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { DynamicFormServiceService } from '../../services/dynamic-form-service.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-timepicker-form',
    templateUrl: './timepicker-form.component.html',
    standalone: false
})
export class TimepickerFormComponent implements OnInit,OnDestroy {
  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  formValue: any;
  ngModelValue: any;
  public subscriptions: Subscription[] = [];
  constructor(private dynamicService: DynamicFormServiceService, private broadcastService: BroadcastService) { }

  ngOnInit() {
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    if (this.isRequired) {
      this.group.get(this.field.labelCode).setValidators(Validators.required);
      this.group.updateValueAndValidity();
    }
    this.formValue = this.field.labelCode;
    this.setFormValue();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  setFormValue() {
    this.ngModelValue = '';
    this.field.labelCode = this.formValue;
    this.subscriptions.push(this.broadcastService.subscribe().subscribe(message => {
      if (message.type === this.formValue) {
        const value = message.payload;
        const localDate = new Date(value);
        const localhours = localDate.getHours();
        const localminutes = localDate.getMinutes();
        const completeTime = localhours + ':' + localminutes;
        this.ngModelValue = completeTime;
      }
    }));
  }

  convertTimeToTwentyFourHoursFormat(val: string) {
    return moment(val, 'hh:mm A').format('HH:mm');
  }

  updateValue(event) {
    const time = this.convertTimeToTwentyFourHoursFormat(event);
    const currentDateTime = this.getLocalTime(time);
    this.group.get(this.formValue).setValue(currentDateTime);
    this.group.updateValueAndValidity();
  }

  getLocalTime(time) {
    const hours = time.split(':')[0];
    const minutes = time.split(':')[1];
    const currentDate = new Date();
    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    return currentDate;
  }

}
